"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRecord = void 0;
function mapRecord(record, mapper) {
    const result = {};
    for (const key in record) {
        if (Object.prototype.hasOwnProperty.call(record, key)) {
            result[key] = mapper(record[key], key);
        }
    }
    return result;
}
exports.mapRecord = mapRecord;
//# sourceMappingURL=mapRecord.js.map